<div class="multiselect" (click)="toggleOptions()">
    <div class="select-box">
      <span>{{ selectedOptions.length ? selectedOptions.join(', ') : 'Selecionar opções' }}</span>
      <span>&#9660;</span>
    </div>
    <div class="options" *ngIf="isOptionsVisible">
      <label *ngFor="let option of options">
        <input type="checkbox" [value]="option" (change)="onCheckboxChange($event)" [checked]="selectedOptions.includes(option)">
        {{ option }}
      </label>
    </div>
  </div>